import * as React from 'react'
import styled from 'styled-components'

import { VideoFullData } from '../../../interfaces'
import BaseVideoCard from './BaseVideoCard'

const ItemDiv = styled.div`
  display: flex;
  flex-direction: column;

  // mobile
  margin: 5px 20px;
  width: calc(100% - 40px);
  height: calc((100% - 10px) * 0.6 + 120px);

  // tablet
  @media (min-width: 43em) {
    width: calc(50% - 40px);
    height: calc((50% - 40px) * 0.6 + 120px);
  }

  @media (min-width: 62em) {
    width: calc(50% - 40px);
    height: calc((50% - 40px) * 0.6 + 120px);
  }

  @media (min-width: 82em) {
    width: calc(100% / 3 - 40px);
    height: calc((100% / 3 - 40px) * 0.6 + 120px);
  }
`

interface Props {
  item?: VideoFullData
}

const ProfileVideoCard = ({ item }: Props): JSX.Element => {
  return (
    <ItemDiv>
      <BaseVideoCard {...item} />
    </ItemDiv>
  )
}

export default ProfileVideoCard
